<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="direction.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Родительская группа</label>
            <crm-direction-single-select
              [directions]="directions"
              [(selectedDirection)]="direction.parent"
              [groupsOnly]="true"
              [showClear]="true"
              appendTo="body"></crm-direction-single-select>
            <small
              *ngIf="errors?.parent"
              class="p-error">
              {{ errors.parent | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Пользователи</label>
            <crm-user-and-group-multi-select
              [(selectedEntities)]="directionGroupUsers"
              [rememberSelected]="true"
              [withBots]="true"
              (selectedEntitiesChange)="onChangeUsersAndGroup()"
              appendTo="body"></crm-user-and-group-multi-select>
          </div>

          <div
            *ngIf="!direction.parent"
            class="field">
            <label class="font-medium">Цвет</label>
            <div class="flex align-items-end gap-3">
              <crm-color-picker
                [nullable]="true"
                [color]="direction.color"
                (colorChange)="onColorPickerChange($event)"></crm-color-picker>
              <div
                class="direction-group-color-preview"
                [class.direction-group-color-preview--empty]="!direction.color"
                [ngStyle]="direction.color ? { 'background-color': direction.color } : null"></div>
            </div>
            <div class="p-inputgroup crm-hex-inputgroup mt-2">
              <span class="p-inputgroup-addon">Hex</span>
              <crm-input-text
                [value]="direction.color ?? ''"
                (valueChange)="changeColor($event)"
                [isError]="$any(errors?.color)"
                class="w-full"></crm-input-text>
            </div>

            <small
              *ngIf="errors?.color"
              class="p-error">
              {{ errors.color | join }}
            </small>
          </div>

          <div
            *ngIf="direction.deleted"
            class="text-right">
            <p-tag
              severity="danger"
              value="Удалена"
              styleClass="mt-2"></p-tag>
          </div>
        </div>
      </p-card>

      <div
        class="mt-3"
        *ngIf="formStoreService.getState.forms[this.index]?.isEdit">
        <crm-directory-common-history
          [entityName]="DirectoryCommonHistoryTypeEnum.DIRECTION_GROUP"
          [entityId]="formStoreService.getState.forms[this.index]?.entityId"
          [apiService]="directionService">
        </crm-directory-common-history>
      </div>
    </div>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveDirection()"></crm-button>
      <div class="flex align-items-center gap-2">
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && !direction.deleted"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteDirection()"></crm-button>
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && direction.deleted"
          icon="pi pi-undo"
          label="Восстановить"
          styleClass="p-button-info p-button-text"
          (onClick)="restoreDirection()"></crm-button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
